import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import ABaseComponent from "Components/Base/ABaseComponent";
import { Client, PorterViewModel, GetPorterItemListViewModel, IPorterBudget, IPorter } from 'Api/CoreApi';
import ApiProvider from 'Api/ApiProvider';
import cart from 'Store/cart/cart';
import { OrderLineComment } from 'Api/DynamicwebApi';
//import UserInformationComponent from "Components/Base/UserInformationComponent";
import PorterBudgetStore from 'Store/porterBudget/porterBudget';

@Component({})
export default class CartFlowComponent extends ABaseComponent{
    @Prop({ default: "" })
    porterid: string;
    @Prop({ default: "" })
    languageid: string;

    @Prop({ default: () => ({}) })
    sessionBudget: IPorterBudget;

    @Prop({ default: () => ({}) })
    sessionPorter: IPorter;

    @Prop({ default: false })
    isReceiptPage: boolean;

    porter: PorterViewModel = new PorterViewModel();
    porterItems: GetPorterItemListViewModel = null;
    client: Client;


    async created() {
        this.client = ApiProvider.getApiClient();
        
        if (this.porterid) {
            if (this.isReceiptPage) {
                await PorterBudgetStore.dispatchFetchPorterBudget();
                this.sessionBudget = PorterBudgetStore.state.porterBudget;
                this.sessionPorter = PorterBudgetStore.state.porter;
            } else {
                this.initializePorter(this.client, this.porterid);

            }

            this.getPorterItems(this.client, this.languageid, this.porterid);
        }
    }



    public setOrderlineComment(event: any, productNumber: string) {
        cart.dispatchUpdateOrderline(new OrderLineComment({
            porterId: this.porterid,
            productNumber: productNumber, 
            comment: event.target.value
        }));
    }

    getPorterItemComment(itemNo: string): string {
        const porterItem = this.porterItems.porterItems.find(a => a.porterItem.itemNo === itemNo);
        if (porterItem) {
            return porterItem.porterItem.comment !== ""
                ? porterItem.porterItem.comment
                : porterItem.porterItem.adjustmentItem;
        } else
            return "";
    }

    get porterName() {
        return this.porter ? this.porter.firstName + " " + this.porter.lastName : null;
    }


    private initializePorter(client: Client, porterId: string) {
        client.getPorterById(porterId)
            .then(async data => {
                this.porter = data.porter;
                //this.sessionPorter = data.porter;
                //await PorterBudgetStore.dispatchFetchPorterBudget({ porterId: data.porter.contactNo });
                
                //this.sessionBudget = PorterBudgetStore.state.currentPorterBudget;
            })
            .catch(e => {
                this.setError(e);
            });
    }

    private getPorterItems(client: Client, languageId: string, porterId: string): void {
        client.getPorterItems(languageId, porterId)
            .then(
                data => {
                    this.porterItems = data;
                    this.loading = false;
                })
            .catch(e => {
                this.setError(e);
            });
    }
}

Vue.component("cart-flow-component", CartFlowComponent);